import { render, staticRenderFns } from "./field-teaching-base.vue?vue&type=template&id=3f699728&scoped=true"
import script from "./field-teaching-base.vue?vue&type=script&lang=js"
export * from "./field-teaching-base.vue?vue&type=script&lang=js"
import style0 from "./field-teaching-base.vue?vue&type=style&index=0&id=3f699728&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f699728",
  null
  
)

export default component.exports